import { Pipe, PipeTransform } from '@angular/core';

import { TimeAgoBase } from './timeago';

@Pipe({
  name: 'rtTimeAgoAsync',

  pure: false,
})
export class TimeAgoAsyncPipe extends TimeAgoBase implements PipeTransform {
  public transform(
    value: string | number,
    { omitSuffix }: { omitSuffix: boolean } = { omitSuffix: false },
  ): string {
    if (!value) {
      return '';
    }

    return this.getTime(value, omitSuffix);
  }
}
